export default{
    logo:'',
	navBars:{
        			active:'0',
        			list:[
        			
        			
        			{
        				name:'нүүр',
        				subActive:'0',
        				submenu:[
                         {
                            icon:'el-icon-s-data',
                            name:'dashboard',
                            type:'evo',
                            level:2,
                            pathname:'dashboard_index'
                        },
                        
                        {
                            icon:'el-icon-user',
                            name:'гишүүд(LIST)',
                            type:'all',
                            admin:false,
                            pathname:'memlist_list'
                        },
                         {
                            icon:'el-icon-user',
                            name:'гишүүд(TREE)',
                            type:'power',
                            admin:false,
                            pathname:'user_list'
                        },
                         {
                            icon:'el-icon-s-goods',
                            name:'админууд',
                             type:'evo',
                             admin:true,
                            pathname:'admin_list'
                        },
                        {
                            icon:'el-icon-files',
                            name:'мастерууд',
                             type:'all',
                             admin:false,
                            pathname:'master_list'
                        },
                        {
                            icon:'el-icon-files',
                            name:'админууд',
                             type:'all',
                             admin:false,
                            pathname:'bon_list'
                        },
                        {
                            icon:'el-icon-files',
                            name:'дэд админууд',
                             type:'all',
                             admin:false,
                            pathname:'bubon_list'
                        },
                        {
                            icon:'el-icon-connection',
                            name:'төлөөлөгчид',
                             type:'all',
                             admin:false,
                            pathname:'zp_list'
                        },
                         
                        {
                            icon:'el-icon-connection',
                            name:'салбарууд',
                             type:'evo',
                             admin:false,
                            pathname:'sp_list'
                        },
                        {
                            icon:'el-icon-s-custom',
                            name:'гишүүн бүрийн орлого зарлага',
                             type:'all',
                             admin:false,
                            pathname:'inout_list'
                        },
                         {
                            icon:'el-icon-s-custom',
                            name:'партнерын орлого зарлага',
                             type:'all',
                             admin:false,
                            pathname:'inoutzp_list'
                        },
                        
                            {
                            icon:'el-icon-set-up',
                            name:'RACE결과',
                             type:'race',
                             admin:false,
                            pathname:'race_list'
                        },
                       
                        {
                            icon:'el-icon-document-copy',
                            name:'구매내역(RACE)',
                             type:'race',
                             admin:false,
                            pathname:'buy_list'
                        },
                          {
                            icon:'el-icon-finished',
                            name:'RACE리스트',
                             type:'race',
                             admin:false,
                            pathname:'racelist_list'
                        },

                         

                        {
                            icon:'el-icon-copy-document',
                            name:'бооцооны түүх',
                             type:'evo',
                             admin:false,
                            pathname:'betting_list',
                            children: [{
                                icon:'el-icon-star-off',
                                name:'нийт бооцооны түүх',
                                pathname:'betting_list1',

                            },{
                                icon:'el-icon-star-off',
                                name:'бооцооны төлвийн огноо',
                                pathname:'betting_list2',

                            },{
                                icon:'el-icon-star-off',
                                name:'огноогоор тоглоомоор',
                                pathname:'betting_list3',

                            },{
                                icon:'el-icon-star-off',
                                name:'огноогоор хэрэглэгчээр',
                                pathname:'betting_list4',

                            }]
                        },
                       
                         {
                            icon:'el-icon-attract',
                            name:'losing тооцоо',
                            type:'aaa',
                            admin:false,
                            level:2,
                            pathname:'losinglist_list'
                        },
                        {
                            icon:'el-icon-attract',
                            name:'losing тооцоо',
                            type:'aaa',
                            admin:false,
                            level:2,
                            pathname:'losinglist_bon'
                        },
                        {
                            icon:'el-icon-coin',
                            name:'орлого зарлагын хуулга',
                             type:'all',
                             admin:false,
                            pathname:'money_list'
                        },
                         {
                            icon:'el-icon-tickets',
                            name:'гар аргаар хийсэн цэнэг таталтын хуулга',
                             type:'all',
                             admin:false,
                            pathname:'moneybak_list'
                        },
                        {
                            icon:'el-icon-document-remove',
                            name:'손실금(RACE) ',
                             type:'race',
                             admin:false,
                            pathname:'lossrace_list'
                        },

                         {
                            icon:'el-icon-notebook-1',
                            name:'moneylog',
                             type:'evo',
                             admin:false,
                            pathname:'moneylogs_list',
                             children: [{
                                icon:'el-icon-star-off',
                                name:'гишүүны moneylog',
                                pathname:'moneylogs_list_user',

                            },{
                                icon:'el-icon-star-off',
                                name:'партнерын moneylog',
                                pathname:'moneylogs_list_pt',

                            }]
                        },
                         {
                            icon:'el-icon-notebook-1',
                            name:'moneylog',
                             type:'race',
                             admin:false,
                            pathname:'moneylogs_list',
                           
                        },

                         {
                            icon:'el-icon-notebook-1',
                            name:'moneylog',
                             type:'pp',
                             admin:false,
                            pathname:'moneylogs_list',
                           
                        },
                         {
                            icon:'el-icon-s-custom',
                            name:'өдөр өдрийн rolling',
                             type:'evo',
                             admin:false,
                            pathname:'rdp_list'
                        },
                         {
                            icon:'el-icon-bangzhu',
                            name:'тооцоо',
                             type:'power',
                             admin:false,
                            pathname:'calculation_list'
                        },
                        {
                            icon:'el-icon-bangzhu',
                            name:'тооцоо',
                             type:'race',
                             admin:false,
                            pathname:'act_list'
                        },
                          {
                            icon:'el-icon-document-checked',
                            name:'출석체크',
                             type:'race',
                             admin:false,
                            pathname:'dcheck_list'
                        },
        				  
                        {
                            icon:'el-icon-collection-tag',
                            name:'захианууд',
                             type:'evo',
                             admin:false,
                            pathname:'memo_list',
                             children: [{
                                icon:'el-icon-star-off',
                                name:'гишүүний захиа',
                                pathname:'memo_list_user',

                            },{
                                icon:'el-icon-star-off',
                                name:'партнерын захиа',
                                pathname:'memo_list_pt',

                            }]
                        },
                        {
                            icon:'el-icon-collection-tag',
                            name:'쪽지관리',
                             type:'race',
                             admin:false,
                            pathname:'memo_list',
                        },
                        {
                            icon:'el-icon-collection-tag',
                            name:'쪽지관리',
                             type:'pp',
                             admin:false,
                            pathname:'memo_list',
                        },
                        {
                            icon:'el-icon-chat-dot-square',
                            name:'мэдээлэлийн төв',
                             type:'all',
                             admin:false,
                            pathname:'qa_list'
                        },
                        {
                            icon:'el-icon-notebook-1',
                            name:'зарын самбар',
                            admin:false,
                             type:'all',
                            pathname:'board_list'
                        },
                        {
                            icon:'el-icon-edit-outline',
                            name:'popup тохиргоо',
                             type:'all',
                             admin:false,
                            pathname:'alert_list'
                        },
                         
                         
                         
                         {
                            icon:'el-icon-edit',
                            name:'хариултууд',
                             type:'all',
                             admin:false,
                            pathname:'autoqa_list'
                        },
                          {
                            icon:'el-icon-folder-checked',
                            name:'нэвтрэлт',
                             type:'all',
                             admin:false,
                            pathname:'online_list'
                        },
                        {
                            icon:'el-icon-reading',
                            name:'нэвтрэлтийн түүх',
                             type:'all',
                             admin:false,
                            pathname:'acclist_list'
                        },
                         {
                            icon:'el-icon-date',
                            name:'цогц бүртгэл',
                             type:'all',
                             admin:false,
                            pathname:'log_list'
                        },
                        {
                            icon:'el-icon-s-tools',
                            name:'сайтын тохиргоо',
                             type:'all',
                             admin:false,
                            pathname:'settings_list'
                        },

                        {
                            icon:'el-icon-document-copy',
                            name:'бооцооны түүх(powerball)',
                             type:'power',
                             admin:false,
                            pathname:'order_list',
                            
                        },
                         {
                            icon:'el-icon-document-copy',
                            name:'구매내역(4조합)',
                             type:'ppgro',
                             admin:false,
                            pathname:'ordergro_list',
                            
                        },
                        {
                            icon:'el-icon-document-copy',
                            name:'구매내역(API)',
                             type:'pp_out',
                             admin:false,
                            pathname:'orderapi_list',
                            
                        },
                      
                        
                        {
                            icon:'el-icon-monitor',
                            name:'powerball үр дүн',
                             type:'power',
                             admin:false,
                            pathname:'powerball_list'
                        },
                        {
                            icon:'el-icon-copy-document',
                            name:'사다리결과',
                             type:'pp',
                             admin:false,
                            pathname:'sadari_list'
                        },

                        {
                            icon:'el-icon-monitor',
                            name:'파워볼 결과(보글)',
                             type:'pp3',
                             admin:false,
                            pathname:'powerball_bg_list'
                        },
                        {
                            icon:'el-icon-copy-document',
                            name:'사다리결과(보글)',
                             type:'pp3',
                             admin:false,
                            pathname:'sadari_bg_list'
                        },
                        {
                            icon:'el-icon-baseball',
                            name:'тоглоомны зохицуулалт',
                             type:'all',
                             admin:true,
                            pathname:'game_list'
                        },
                        //  {
                        //     icon:'el-icon-postcard',
                        //     name:'기본설정',
                        //      type:'evo',
                        //      admin:false,
                        //     pathname:'configlist_list'
                        // },
                        //   {
                        //     icon:'el-icon-s-platform',
                        //     name:'사이트현황',
                        //      type:'evo',
                        //      admin:false,
                        //     pathname:'sitestat_list'
                        // },
                        //   {
                        //     icon:'el-icon-money',
                        //     name:'입츨금통계',
                        //      type:'evo',
                        //      admin:false,
                        //     pathname:'moneystat_list'
                        // },
                        //  {
                        //     icon:'el-icon-wallet',
                        //     name:'롤링금통계',
                        //      type:'evo',
                        //      admin:false,
                        //     pathname:'rollingstat_list'
                        // }
        				]
        			},
        			
        			

        			]

        		}
                
        		
    		
}


//////////////////
// WEBPACK FOOTER
// ./config/config_mg.js
// module id = null
// module chunks = 